import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { Page } from '@tracking';

import FirstSection from './FirstSection';
import SecondSection from './SecondSection';

interface FreeProTrialProps {
  env: Env;
  offerCode: string;
  costChargedToday: number;
}

const queryClient = new QueryClient();

const FreeProTrial = ({ env, offerCode, costChargedToday }: FreeProTrialProps) => {
  const { Track } = useEventTracking({
    page: Page.FreeProTrial,
  });
  const hydrated = useServerSideRendering();

  return (
    <Track>
      <QueryClientProvider client={queryClient}>
        <AppContextProvider env={env}>
          <div className="px-16 sm:px-28">
            <div className="md:max-w relative mx-auto w-full sm:max-w-[1040px] xl:max-w-[1250px]">
              <div className="flex flex-wrap justify-between">
                {hydrated && (
                  <>
                    <FirstSection offerCode={offerCode} costChargedToday={costChargedToday} />
                    <SecondSection />
                  </>
                )}
              </div>
            </div>
          </div>
        </AppContextProvider>
      </QueryClientProvider>
    </Track>
  );
};

export default FreeProTrial;
